const QUERY_PARAMS = {
  CHAIN: 'chain',
} as const;

export { QUERY_PARAMS, QUERY_PARAMS as QP };
